import { render, staticRenderFns } from "./BoardWriteFaqLayout.vue?vue&type=template&id=1f73047d&scoped=true"
import script from "./BoardWriteFaqLayout.vue?vue&type=script&lang=js"
export * from "./BoardWriteFaqLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f73047d",
  null
  
)

export default component.exports